// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-toast .p-toast-message.p-toast-message-error,
.p-toast .p-toast-message.p-toast-message-success{
    background: var(--blue);
    color: black;
}
`, "",{"version":3,"sources":["webpack://./src/css/toast.css"],"names":[],"mappings":"AAAA;;IAEI,uBAAuB;IACvB,YAAY;AAChB","sourcesContent":[".p-toast .p-toast-message.p-toast-message-error,\n.p-toast .p-toast-message.p-toast-message-success{\n    background: var(--blue);\n    color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
